module.exports = __webpack_public_path__ + "img/32.53048939.png";